<template>
  <!-- prettier-ignore -->
  <the-modal
    v-model="isOpen"
    x-only
    full-screen
  >
    <div class="quiz__modal">
      <img
        v-if="browser.isDesktop"
        class="quiz__logo"
        alt="logo"
        height="36px"
        width="111px"
        :src="logo"
      />
      <component
        :is="current.component"
        v-bind="current.props"
        @close="isOpen = false"
        @error="current.error"
        @update="current.proceed"
      />
    </div>
  </the-modal>
</template>

<script setup>
import { computed, defineAsyncComponent, reactive, ref } from 'vue'

import { EVENT_QUIZ } from '@/config/events'
import { events$ } from '@/services'
import logo from '@/assets/logo.svg'
import { useBrowser, useToast, useQuiz } from '@/hooks'
import { useI18n } from 'vue-i18n'

// Hooks
const { browser } = useBrowser()
const { locale, t } = useI18n()
const { addToast } = useToast()
const { sendContactData } = useQuiz()

// Init
const QUIZ_GAME = 'quiz-game'
const QUIZ_DATA = 'quiz-data'

// Data
const current = reactive({})
const dataContent = reactive({})
const gameContent = reactive({})
const initialStep = ref(QUIZ_GAME)
const isOpen = ref(false)
const validTo = ref(undefined)

// Computed
const steps = computed(() => {
  return [
    {
      id: QUIZ_GAME,
      component: defineAsyncComponent(() => import('./QuizGame')),
      error: () => {},
      proceed: () => {
        Object.assign(current, findById(QUIZ_DATA))
      },
      props: {
        description: gameContent.description,
        title: gameContent.title,
      },
    },
    {
      id: QUIZ_DATA,
      component: defineAsyncComponent(() => import('./QuizData')),
      error: () => {},
      proceed: async formData => {
        const payload = {
          email: formData.email,
          firstName: formData.firstName,
          lastName: formData.lastName,
          mobile: formData.mobile,
          salutation: formData.salutation,
          street: formData.street,
          streetNumber: formData.streetNumber,
          town: formData.zip.town,
          zipCode: formData.zip.zipCode,
          language: locale.value,
        }

        await sendContactData(payload)

        events$.emit(EVENT_QUIZ.SUBMIT, validTo.value)
        isOpen.value = false
        addToast({
          text: t('quiz.notificationMessage'),
        })
      },
      props: {
        description: dataContent.description,
        title: dataContent.title,
      },
    },
  ]
})
// Methods
function findById(id) {
  return steps.value.find(s => s.id === id)
}

function openQuizModal() {
  reset()
  isOpen.value = true
}

function reset() {
  Object.assign(current, findById(initialStep.value))
}

// Watcher

// Lifecycle hooks
events$.on(EVENT_QUIZ.OPEN, payload => {
  Object.assign(dataContent, payload.dataContent)
  Object.assign(gameContent, payload.gameContent)
  validTo.value = payload.validTo
  openQuizModal()
})
</script>

<style scoped name="mobile">
.quiz__modal {
  padding: 64px 8px 0;
}
</style>

<style name="desktop" scoped>
@media (--md) {
  .quiz__logo {
    position: absolute;
    top: 24px;
    left: 56px;
    height: 36px;
    width: 111px;
  }

  .quiz__modal {
    padding: 88px 0 0;
    max-width: 800px;
    margin: 0 auto;
  }
}
</style>
